import { create } from "zustand";
import { HFROnboardingSubStates, OnboardingNavigationStates } from "./enums";
import { THprHfrOnboardingStore } from "./types";

const useHprHfrOnboardingStore = create<THprHfrOnboardingStore>((set, get) => ({
  openModal: false,
  setOpenModal: (open) => {
    set({ openModal: open });
  },
  activeScreen: OnboardingNavigationStates.AADHAR,
  setActiveScreen: (screen) => {
    set({ activeScreen: screen });
  },
  setTransactionId(id) {
    set({ transactionId: id });
  },
  hprIdNumber: null,
  setHprIdNumber(hprId) {
    set({ hprIdNumber: hprId });
  },
  setDoctorId(id) {
    set({ doctorId: id });
  },
  setMaskedMobileNumber(maskedNumber) {
    set({ maskedMobileNumber: maskedNumber });
  },
  setSuggestedHprIds(ids) {
    set({
      suggestedHprIds: ids,
    });
  },
  setHfrFacilityId: (facilityId) => {
    set({
      hfrFacilityId: facilityId,
    });
  },
  setCreatedHprId: (hprId) => {
    set({ createdHprId: hprId });
  },
  clearHprHfrStore: () => {
    set({
      activeScreen: OnboardingNavigationStates.AADHAR,
      maskedMobileNumber: undefined,
      transactionId: undefined,
      suggestedHprIds: undefined,
      createdHprId: undefined,
      hfrFacilityId: undefined,
      isExistingHfrOnboarding: false,
    });
  },
  setClinicId: (clinicId) => set({ selectedClinicId: clinicId }),
  setAadhaarNumber: (num) => set({ aadhaarNumber: num }),

  setSubActiveScreen: (subActiveScreen) => set({ subActiveScreen }),
  // subActiveScreen: HFROnboardingSubStates.EXISTING_HFR_FORM,

  setClinicIdForExistingHfr: (clinicId) =>
    set({ clinicIdForExistingHfr: clinicId }),
  existingHfrId: "",
  setExistingHfrId: (hfrId) => set({ existingHfrId: hfrId }),
  setExistingHfrDetails: (hfrDetails) => set({ existingHfrDetail: hfrDetails }),
  clearExistingHfrDetails: () =>
    set({
      existingHfrId: "",
      subActiveScreen: undefined,
      clinicIdForExistingHfr: undefined,
      existingHfrDetail: undefined,
    }),
  isExistingHfrOnboarding: false,
  setIsExistingHfrOnboarding: (value) =>
    set({ isExistingHfrOnboarding: value }),
}));

export default useHprHfrOnboardingStore;
